import {
  GET_LABREQUESTASSIGNMENT_FAIL,
  GET_LABREQUESTASSIGNMENT_SUCCESS,
  GET_LABREQUESTASSIGNMENTS_FAIL,
  GET_LABREQUESTASSIGNMENTS_SUCCESS,
  ADD_LABREQUESTASSIGNMENT_SUCCESS,
  ADD_LABREQUESTASSIGNMENT_FAIL,
  UPDATE_LABREQUESTASSIGNMENT_SUCCESS,
  UPDATE_LABREQUESTASSIGNMENT_FAIL,
  DELETE_LABREQUESTASSIGNMENT_SUCCESS,
  DELETE_LABREQUESTASSIGNMENT_FAIL,  
  SET_STATE_LABREQUESTASSIGNMENT
} from "./actionTypes";

const INIT_STATE = {
  labRequestAssignments: [],
  labRequestAssignment: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labRequestAssignments = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABREQUESTASSIGNMENTS_SUCCESS:
      return {
        ...state,
        labRequestAssignments: action.payload.labRequestAssignments,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LABREQUESTASSIGNMENT:
      return { ...state, loading: action.payload }

    case GET_LABREQUESTASSIGNMENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABREQUESTASSIGNMENT_SUCCESS:
      return {
        ...state,
        labRequestAssignments: [...state.labRequestAssignments, action.payload],
      };

    case ADD_LABREQUESTASSIGNMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABREQUESTASSIGNMENT_SUCCESS:
      return {
        ...state,
        labRequestAssignments: state.labRequestAssignments.map(labRequestAssignment =>
          labRequestAssignment.id.toString() === action.payload.id.toString()
            ? { ...action.payload, labRequestAssignment }
            : labRequestAssignment
        ),
      };

    case UPDATE_LABREQUESTASSIGNMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABREQUESTASSIGNMENT_SUCCESS:
      return {
        ...state,
        labRequestAssignments: state.labRequestAssignments.filter(
          labRequestAssignment => labRequestAssignment.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABREQUESTASSIGNMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABREQUESTASSIGNMENT_SUCCESS:
      return {
        ...state,
        labRequestAssignment: action.payload,
      };

    case GET_LABREQUESTASSIGNMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labRequestAssignments;
